import { Link } from 'react-router-dom';
import { Crane } from '../mascot/Crane';

interface CompletionScreenProps {
  huntId: string;
  fragments: Record<number, string>;
}

export function CompletionScreen({ huntId, fragments }: CompletionScreenProps) {
  const assembledPhrase = Object.entries(fragments)
    .sort(([a], [b]) => parseInt(a) - parseInt(b))
    .map(([, fragment]) => fragment)
    .join(' ');

  return (
    <div className="max-w-2xl mx-auto px-4 py-12 text-center">
      {/* Confetti effect placeholder */}
      <div className="mb-8">
        <Crane pose="celebrating" size="lg" />
      </div>

      <h1 className="text-3xl font-bold text-primary mb-4">
        You Did It!
      </h1>

      <div className="card mb-8">
        <p className="text-lg text-text-dark italic leading-relaxed">
          "You unfolded the whole thing and then you found the creases. Thanks for playing in the gap, friend. The map was never the territory."
        </p>
        <p className="mt-4 text-text-light">— Crane</p>
      </div>

      {assembledPhrase && (
        <div className="card mb-8 bg-cream">
          <h3 className="text-sm font-semibold text-text-light uppercase mb-2">
            The Final Phrase
          </h3>
          <p className="text-2xl font-bold text-primary">
            {assembledPhrase}
          </p>
        </div>
      )}

      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link to={`/h/${huntId}/board`} className="btn-primary">
          View Leaderboard
        </Link>
        <Link to="/" className="btn-outline">
          Back to Hunts
        </Link>
      </div>

      <p className="mt-8 text-sm text-text-light">
        If you completed during the open season, you're eligible for prizes.
        Winners will be notified by email.
      </p>
    </div>
  );
}
